import React from "react";
import { useTranslation } from "react-i18next";
import {
  Page,
  Card,
  Banner,
  InlineError,
  Layout,
  Link,
} from "@shopify/polaris";

export default function ErrorPage({ error }) {
  const { t } = useTranslation();
  const errorMessage = error.message || error.toString();

  // Return a page displaying the error
  // Explain that we have been notified and will fix it as soon as possible

  return (
    <Page>
      <Layout>
        <Layout.Section>
          <Banner title={t("common.error")} status="critical"></Banner>
        </Layout.Section>
        <Layout.Section>
          <Card
            sectioned
            primaryFooterAction={{
              content: t("common.reload"),
              onAction: () => window.location.reload(),
            }}
          >
            <InlineError message={errorMessage}></InlineError>
            <p>
              {t("common.errorNotification")}{" "}
              <Link
                onClick={() => {
                  window.Beacon("open");
                  window.Beacon("prefill", {
                    subject: "Error: " + errorMessage,
                    // text: "Hello, I need some help with my invoice",
                  });
                  window.Beacon("navigate", "/ask/");
                }}
              >
                {t("common.contactUs")}
              </Link>
            </p>
          </Card>
        </Layout.Section>
      </Layout>
    </Page>
  );
}
